import { render, staticRenderFns } from "./OrderBy.vue?vue&type=template&id=d234dfa0&scoped=true&"
import script from "./OrderBy.vue?vue&type=script&lang=js&"
export * from "./OrderBy.vue?vue&type=script&lang=js&"
import style0 from "./OrderBy.vue?vue&type=style&index=0&id=d234dfa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d234dfa0",
  null
  
)

export default component.exports